"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateSSN = exports.validateRequiredZip = exports.validateRequiredPhone = exports.validateRequiredEmail = exports.validateRequired = exports.validatePhone = exports.validatePercent = exports.validatePasswordStrength = exports.validateNumber = void 0;
var validateRequired = exports.validateRequired = function validateRequired(value) {
  return value === undefined || _.trim(value) === "" ? 'This field is required.' : undefined;
};
var validateNumber = exports.validateNumber = function validateNumber(value) {
  return value && isNaN(value) ? 'Field must be a valid number' : undefined;
};
var validatePhone = exports.validatePhone = function validatePhone(value) {
  if (value) {
    value = value.replace(/[-+ ()]/g, '');
    return isNaN(value) || value.length !== 10 && value.length !== 11 ? 'Field must be a valid phone number.' : undefined;
  } else {
    return undefined;
  }
};
var validateSSN = exports.validateSSN = function validateSSN(value) {
  if (value) {
    value = value.replace(/[- ]/g, '');
    return isNaN(value) || value.length !== 9 ? 'Field must be a valid social security number.' : undefined;
  } else {
    return undefined;
  }
};
var validatePercent = exports.validatePercent = function validatePercent(value) {
  if (value) {
    var numericVal = parseFloat(value);
    return 0 > numericVal || numericVal > 100 ? 'Field must be a valid number (0-100).' : undefined;
  } else {
    return undefined;
  }
};
var validateRequiredPhone = exports.validateRequiredPhone = function validateRequiredPhone(value) {
  var requiredValidation = validateRequired(value);
  if (requiredValidation) {
    return requiredValidation;
  }
  return validatePhone(value);
};
var validateRequiredZip = exports.validateRequiredZip = function validateRequiredZip(value) {
  var requiredValidation = validateRequired(value);
  if (requiredValidation) {
    return requiredValidation;
  }
  return isNaN(value) || value.length !== 5 ? 'Field must be a valid 5 digit zip.' : undefined;
};
var validateRequiredEmail = exports.validateRequiredEmail = function validateRequiredEmail(value) {
  var requiredValidation = validateRequired(value);
  if (requiredValidation) {
    return requiredValidation;
  }
  return !/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(value) ? 'Field must be a valid email address' : undefined;
};
var validatePasswordStrength = exports.validatePasswordStrength = function validatePasswordStrength(value) {
  var requiredValidation = validateRequired(value);
  if (requiredValidation) {
    return requiredValidation;
  }
  return value.length < 8 ? "This password is too short. It must contain at least 8 characters." : undefined;
};